/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMonitoringWorkingCapitalPlanDto } from '../../models/backend-monitoring-working-capital-plan-dto';

export interface MonitoringScenariosWorkingCapitalRetrieve$Params {
  scenario_id: number;
}

export function monitoringScenariosWorkingCapitalRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringScenariosWorkingCapitalRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendMonitoringWorkingCapitalPlanDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringScenariosWorkingCapitalRetrieve.PATH, 'get');
  if (params) {
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendMonitoringWorkingCapitalPlanDto>;
    }),
  );
}

monitoringScenariosWorkingCapitalRetrieve.PATH = '/api/monitoring/scenarios/{scenario_id}/working-capital/';
